<template>
  <div class="box8-page">
    <div class="fcp-title">科学高效的学习路线</div>
    <div class="fcp-text">结合数十年人才培养经验及应用观察，根据职业发展方向为您<br/>提供更科学高效的学习路径</div>
    <ul>
      <li v-for="(item, index) in list" :class="`li-index-0${index+1}`" :key="index">
        <span class="tips">第{{ numArr[index] }}步</span>
        <span class="arrow" v-if="index < 3"></span>
        <div class="cont-info">
          <h2>{{ item.title }}</h2>
          <div class="info-list">
            <span v-for="(v1, i1) in item.info" :key="i1">{{ v1 }}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        numArr: ['一', '二', '三', '四'],
        list:[
          {
            title: 'MySQL',
            info: [
              '· 数据库基本概念',
               '· 数据排序',
              '· 增删改查操作',
               '· 限定查询',
              '· 条件查询',
               '· 窗口函数',
              '· 聚合查询',
               '……',
              '· 分组查询',
             
             
             
             
              
            ]
          },
          {
            title: 'FineReport模块',
            info: [
               '· FineReport介绍及安装操作',
              '· 普通报表和填报报表的制作',
              '· 数据连接操作',
              '· 报表类型与预览模式介绍',
              '· 单元格设置',
              '· 条件属性',
              '· 数据决策系统操作',
              '· 移动端报表',
            ]
          },
          {
            title: 'Tomcat模块',
            info: [
              '· Linux环境下Tomcat安装部署操作',
              '· Windows环境下Tomcat安装部署操作',
              '· Windows环境下Tomcat日志操作',
              '· 调整Tomcat内存操作',
               '· Tomcat浏览器操作',
              '· FineReport工程独立部署',
            ]
          },
          {
            title: 'Kettle模块',
            info: [
              '· 各种组件操作',
              '· 数据抽取、数据转化、数据同步功能',
              '· 插入更新组件',
              '· switch-case组件',
              '· 记录集关联组件',
            ]
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
.box8-page{
  padding: 80px 0 88px;
  background-image: url(../../../assets/coursePage/fcp/box8/box8-bg.png);
  background-size: cover;
  ul{
    width: 686px;
    margin: 48px auto 0;
    
    li{
      margin-top: 36px;
      width: 686px;
      background: linear-gradient(180deg, #D9F1FF 0%, #A4CCFF 100%);
      border-radius: 16px;
      padding: 20px;
      position: relative;
      box-sizing: border-box;
      .tips{
        position: absolute;
        top: 0;
        right: 0;
        width: 120px;
        height: 48px;
        background: #D4B2FF;
        border-radius: 0px 14px 0px 14px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 48px;
        text-align: center;
      }

      .arrow{
        position: absolute;
        bottom: -20px;
        right: 44px;
        width: 34px;
        height: 68px;
        background-image: url(../../../assets/coursePage/fcp/box8/icon-arrow.png);
        background-size: 100% 100%;
      }
      .cont-info{
        border-radius: 16px;
        background-color: #fff;
        background-image: url(../../../assets/coursePage/fcp/box8/icon-card-bg.png);
        background-position: right bottom;
        background-size: 224px 194px;
        background-repeat: no-repeat;
        padding: 48px 0 48px 48px;
        h2{
          font-size: 36px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1F375F;
          line-height: 48px;
          padding-left: 32px;
          position: relative;
          &::after{
            content: "";
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            width: 20px;
            height: 20px;
            background-image: url(../../../assets/coursePage/fcp/box8/icon-drop.png);
            background-size: 100% 100%;
          }
        }
        .info-list{
          display: flex;
          flex-wrap:wrap;
          margin-top: 18px;
          span{
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #86909C;
            line-height: 52px;
          }
        }
      }
    }
    .li-index-01{
      margin-top: 0;
      .cont-info{
        .info-list{
          span:nth-of-type(odd){
            width: 354px;
          }
        }
      }
    }
    .li-index-02{
      .cont-info{
        .info-list{
         
          span:nth-of-type(odd){
            width: 486px;
          }
        }
      }
    }
    .li-index-03{
      .cont-info{
        .info-list{
          span:nth-of-type(4),
          span:nth-of-type(5){
            width: 366px;
          }
        }
      }
    }
    .li-index-04{
      .cont-info{
        .info-list{
          span:nth-of-type(4){
            width: 500px;
          }
        }
      }
    }
  }
}
</style>